/* ========================================================================
//	SINGLE EQUIPMENT PAGE
======================================================================== */

(function ($) {
    
    $('#eq-gallery').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        fade: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        autoplay: false,
        autoplaySpeed: 10000,
        adaptiveHeight: true
    });


    MyTools.touch({ el: $('.thumb'), deactivate: 0, funcDelay: 0, func: function(_args){
        $('#eq-gallery').slick('slickGoTo', _args.index);
    }});

    $($('.thumb')[0]).addClass('active');

    MyTools.initPg('EQUIPAMENTO');
    
})(jQuery, MyTools);